import { render } from "./native.vue?vue&type=template&id=1c2f6509&scoped=true"
import script from "./native.vue?vue&type=script&lang=js"
export * from "./native.vue?vue&type=script&lang=js"

import "./native.vue?vue&type=style&index=0&id=1c2f6509&lang=scss&scoped=true"

import exportComponent from "D:\\Word\\mingyou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2f6509"]])

export default __exports__